<template>
  <!-- te-popup begin -->
  <div class="te-alert d-flex flex-column" @click.stop>
    <a v-if="display.close" class="close" style="z-index: 10; cursor: pointer" @click="close">
      <i class="material-icons">close</i>
    </a>
    <div class="content d-flex align-items-center flex-column flex-grow-1">
      <slot />
    </div>
    <div class="p-3">
      <button v-if="display.cancel"
          class=" btn-success bg-customize border-customize"
          block
          size="lg"
          @click="close">
        {{ cancelWording }}
      </button>
        <b-button
          v-if="display.confirm"
          class=" btn-success bg-customize border-customize"
          block
          size="lg"
          @click="confirm"
          :style="`background: rgba(${rGBaCode}); border-color: rgba(${rGBaCode})`"
          >{{ confirmWording }}</b-button
        >
    </div>
  </div>
  <!-- te-popup end -->
</template>

<script>
export default {
  props: {
    // 顯示設定
    display: {
      type: Object,
      default() {
        return {
          // 關閉鈕
          close: true,
          // 取消鈕
          cancel: true,
          // 確認鈕
          confirm: true,
        };
      },
    },
    // 取消按鈕文案
    cancelWording: {
      type: String,
    },
    // 按鈕顏色
    rGBaCode: {
      type: String,
    },
    // 確認按鈕文案
    confirmWording: {
      type: String,
    },
    // 立即關閉
    rightnowClose: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  methods: {
    // 關閉
    close() {
      this.$emit('close');
    },
    // 確認
    confirm() {
      const vm = this;
      if (this.rightnowClose) {
        vm.close();
      }
      vm.$emit('confirm');
    },
  },
};
</script>
